import React from 'react';

import { Listing } from '@kamernet/core/ApiClient/Kamernet';
import { CommonStyles } from '@kamernet/styles/CommonStyles';
import { useMediaIsDesktop } from '@kamernet/utilities/Media/useMediaIsDesktop';

import { CardSlider } from '@kamernet/components/CardSlider';
import { ListingCard } from '@kamernet/modules/Listing/components/ListingCard';

export interface CarouselGeneratorProps {
  listings: Array<Listing>;
}

const CarouselGeneratorInternal = ({ listings }: CarouselGeneratorProps) => {
  const isDesktop = useMediaIsDesktop();
  const visibleItemsCount = 3;

  return (
    <div className={CommonStyles.margin_bottom_3}>
      <CardSlider visibleItemsCount={isDesktop ? visibleItemsCount : 1}>
        {listings.map(listing => (
          <ListingCard
            key={listing.listingId}
            listingId={listing.listingId}
            thumbnailUrl={listing.thumbnailUrl}
            fullPreviewImageUrl={listing.fullPreviewImageUrl}
            isTopAdvert={listing.isTopAdvert}
            furnishingId={listing.furnishingId}
            availabilityStartDate={listing.availabilityStartDate}
            availabilityEndDate={listing.availabilityEndDate}
            streetName={listing.street}
            streetSlug={listing.streetSlug}
            cityName={listing.city}
            citySlug={listing.citySlug}
            isFavorite={listing.isFavorite}
            surfaceArea={listing.surfaceArea}
            listingType={listing.listingType}
            totalRentalPrice={listing.totalRentalPrice}
            utilitiesIncluded={listing.utilitiesIncluded}
            isNewAdvert={listing.isNewAdvert}
            isReactForFree={listing.isReactForFree}
            isStudentHouseAdvert={listing.isStudentHouseAdvert}
          />
        ))}
      </CardSlider>
    </div>
  );
};

export const CarouselGenerator = React.memo(CarouselGeneratorInternal);
